module.exports = __webpack_public_path__ + "static/media/nrna2.766887e2.png";